import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {Backdrop, Card, Title, Message, Actions, CancelBtn, ConfirmBtn} from "./styles";

/**
 * Diálogo de confirmação reutilizável do Group Manager (styled, sem window.confirm).
 * Controlado: renderiza só quando `open`. Clicar no backdrop = cancelar.
 */
const ConfirmDialog = ({open, title, message, confirmLabel, danger, onConfirm, onCancel}) => {
    const {t} = useTranslation();
    if (!open) return null;
    return (
        <Backdrop onClick={onCancel}>
            <Card onClick={(e) => e.stopPropagation()}>
                {title ? <Title>{title}</Title> : null}
                <Message>{message}</Message>
                <Actions>
                    <CancelBtn type="button" onClick={onCancel}>{t("words.cancel")}</CancelBtn>
                    <ConfirmBtn type="button" $danger={danger} onClick={onConfirm}>
                        {confirmLabel || t("words.confirm")}
                    </ConfirmBtn>
                </Actions>
            </Card>
        </Backdrop>
    );
};

ConfirmDialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    message: PropTypes.string,
    confirmLabel: PropTypes.string,
    danger: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
};

export default ConfirmDialog;
